import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from '@core/providers/http';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ClienteService {
  public params = new HttpParams();

  constructor(private readonly apiService: ApiService) { }

  // listar Clientes
  list(params?: any): Observable<any> {
    return this.apiService.get(`/api/Clientes`, params ? new HttpParams({
      fromObject: params
    }) : this.params,
    ).pipe(
      map(response => response)
    );
  }

  //listar por id
  show(id: string): Observable<any> {
    return this.apiService.get(
      `/api/Clientes/${id}`,
    ).pipe(
      map(response => response)
    );
  }

  /**
* Cria uma nova Cliente
* @param Cliente
* @returns Observable<any>
*/
  public store(Cliente: any): Observable<any> {
    return this.apiService.post(`/api/Clientes`, Cliente);
  }

  // atualizar Cliente
  update(Cliente: any, id: string): Observable<any> {
    return this.apiService.put(`/api/Clientes/${id}`, Cliente);
  }

  delete(id: string): Observable<any> {
    return this.apiService.delete(`/api/Clientes/${id}`);
  }
}